import { NgModule, ApplicationRef } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { NotFoundComponent } from './shared/components/not-found.component';
import { ModalModule } from "ngx-bootstrap";

@NgModule({
  imports: [
    AppRoutingModule,
    CoreModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    AppComponent,
    NotFoundComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/app.module.ts